import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39eb22b3&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBoard: require('/opt/build/repo/components/AppBoard.vue').default})
